import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import internals from '../internals/index.js';
import deepmerge from '../utils/deepmerge.js';

var _excluded = ["fontFamily", "fontFamilyBody", "fontSize", "fontWeight", "h1", "h2", "h3", "h4", "h5", "h6", "body1", "body2", "body3", "body4", "body5", "body6", "allVariants", "pxToRem"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var type = internals.type;
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}
var defaultFontFamily = "'Open Sans', sans-serif";
function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? type.fontFamily : _ref$fontFamily,
      _ref$fontFamilyBody = _ref.fontFamilyBody,
      fontFamilyBody = _ref$fontFamilyBody === void 0 ? type.fontFamilyBody : _ref$fontFamilyBody,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? type.fontSize["default"] : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? type.fontWeight : _ref$fontWeight,
      _ref$h = _ref.h1,
      h1 = _ref$h === void 0 ? type.h1 : _ref$h,
      _ref$h2 = _ref.h2,
      h2 = _ref$h2 === void 0 ? type.h2 : _ref$h2,
      _ref$h3 = _ref.h3,
      h3 = _ref$h3 === void 0 ? type.h3 : _ref$h3,
      _ref$h4 = _ref.h4,
      h4 = _ref$h4 === void 0 ? type.h4 : _ref$h4,
      _ref$h5 = _ref.h5,
      h5 = _ref$h5 === void 0 ? type.h5 : _ref$h5,
      _ref$h6 = _ref.h6,
      h6 = _ref$h6 === void 0 ? type.h6 : _ref$h6,
      _ref$body = _ref.body1,
      body1 = _ref$body === void 0 ? type.body1 : _ref$body,
      _ref$body2 = _ref.body2,
      body2 = _ref$body2 === void 0 ? type.body2 : _ref$body2,
      _ref$body3 = _ref.body3,
      body3 = _ref$body3 === void 0 ? type.body3 : _ref$body3,
      _ref$body4 = _ref.body4,
      body4 = _ref$body4 === void 0 ? type.body4 : _ref$body4,
      _ref$body5 = _ref.body5,
      body5 = _ref$body5 === void 0 ? type.body5 : _ref$body5,
      _ref$body6 = _ref.body6,
      body6 = _ref$body6 === void 0 ? type.body6 : _ref$body6,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = _objectWithoutProperties(_ref, _excluded);
  var coef = fontSize["default"] / 14;
  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / fontSize.page * coef, "rem");
  };
  var buildVariant = function buildVariant(_ref2) {
    var fontFamilyBuildVariant = _ref2.fontFamily,
        fontWeightBuildVariant = _ref2.fontWeight,
        fontSizeBuildVariant = _ref2.fontSize,
        lineHeight = _ref2.lineHeight,
        letterSpacing = _ref2.letterSpacing,
        textTransform = _ref2.textTransform;
    return _objectSpread(_objectSpread(_objectSpread({
      fontFamily: fontFamilyBuildVariant,
      fontWeight: fontWeightBuildVariant,
      fontSize: pxToRem(Number(fontSizeBuildVariant)),
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(Number(letterSpacing) / Number(fontSizeBuildVariant)), "em")
    } : {}), textTransform && {
      textTransform: textTransform
    }), allVariants);
  };
  var variants = {
    h1: buildVariant(h1),
    h2: buildVariant(h2),
    h3: buildVariant(h3),
    h4: buildVariant(h4),
    h5: buildVariant(h5),
    h6: buildVariant(h6),
    body1: buildVariant(body1),
    body2: buildVariant(body2),
    body3: buildVariant(body3),
    body4: buildVariant(body4),
    body5: buildVariant(body5),
    body6: buildVariant(body6)
  };
  return deepmerge(_objectSpread({
    pxToRem: pxToRem,
    fontFamily: fontFamily,
    fontFamilyBody: fontFamilyBody,
    fontSize: fontSize,
    fontWeight: fontWeight
  }, variants), other, {
    clone: false
  });
}

export default createTypography;
//# sourceMappingURL=createTypography.js.map
